import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CellAlignmentEnum, ConfigColumn, TypeColumn } from '@eqproject/eqp-table';
import { TranslateService } from '@ngx-translate/core';
import { CommercialProductCategoryEnum } from '../../../models/commercialProduct.model';
import { ActivatedLicenceDTO, PurchasedLicenceDTO, TransferredLicenceDTO } from '../../../models/license.model';
import { GlobalService } from '../../../services/global.service';
import { LicenceService } from '../../../services/licence.service';

@Component({
  selector: 'app-manage-licenses',
  templateUrl: './manage-licenses.component.html',
  styleUrls: ['./manage-licenses.component.scss']
})
export class ManageLicensesComponent implements OnInit {

  //#region DATI TABELLE
  purchasedLicensesData : PurchasedLicenceDTO[] = [];
  transferredLicensesData : TransferredLicenceDTO[] = [];
  receivedLicensesData : TransferredLicenceDTO[] = [];
  activatedLicensesData : ActivatedLicenceDTO[] = [];
  //#endregion

  //#region COLONNE TABELLE
  purchasedLicensesColumns : ConfigColumn[] = [];
  transferredLicensesColumns : ConfigColumn[] = [];
  receivedLicensesColumns : ConfigColumn[] = [];
  activatedLicensesColumns : ConfigColumn[] = [];
  //#endregion

  //#region MODALE DETTAGLIO
  @ViewChild('detailsModal') detailsModal : TemplateRef<any>;
  detailsModalRef : MatDialogRef<TemplateRef<any>>;
  typeToShow : number;
  elementToShow;
  category : string;
  //#endregion



  constructor(private licenseService : LicenceService,
              public translate : TranslateService,
              private dialog : MatDialog) { }

  ngOnInit(): void {
    this.configureColumns();
    this.loadData();
  }

  configureColumns(){
    this.activatedLicensesColumns = [
      {key: 'action', display: '', type: TypeColumn.SimpleAction, styles: {flex: '0 0 6%'},
        actions: [
          {
            name: '',
            icon: 'visibility',
            fn: (element) => this.showDetails(1, element)
          }
        ]
      },
      {key: 'CompanyDenomination', display: this.translate.instant("GENERIC_FIELDS.DENOMINATION"), styles: {flex: '0 0 20%'}},
      // {key: 'CompanyName', display: this.translate.instant("GENERIC_FIELDS.NAME")},
      // {key: 'CompanySurname', display: this.translate.instant("GENERIC_FIELDS.SURNAME")},
      {key: 'CompanyVatNumber', display: this.translate.instant("GENERIC_FIELDS.VATNUMBER"), styles: {flex: '0 0 10%'}},
      // {key: 'CompanyFiscalCode', display: this.translate.instant("GENERIC_FIELDS.FISCALCODE")},
      // {key: 'UserEmail', display: this.translate.instant("GENERIC_FIELDS.EMAIL")},
      {key: 'CommercialProductCode', display: this.translate.instant("GENERIC_FIELDS.CODE"), styles: {flex: '0 0 7%'}},
      {key: 'CommercialProductTitle', display: this.translate.instant("GENERIC_FIELDS.TITLE")},
      // {key: 'Credits', display: this.translate.instant("GENERIC_FIELDS.CREDITS")},
      {key: "CommercialProductCategoryEnum", display: this.translate.instant("GENERIC_FIELDS.CATEGORY"),styles: {flex: '0 0 9%'}, type:TypeColumn.Enum, enumModel:CommercialProductCategoryEnum, multilanguagePrefixKey: "ENUMS.COMMERCIAL_PRODUCT_CATEGORY."},
      {key: 'StartDate', display: this.translate.instant("GENERIC_FIELDS.START_DATE"), type: TypeColumn.Date, styles: {flex: '0 0 7%'}},
      {key: 'EndDate', display: this.translate.instant("GENERIC_FIELDS.END_DATE"),type: TypeColumn.Date, styles: {flex: '0 0 7%'}},
      {key: 'InvoiceQuantity', display: this.translate.instant("GENERIC_LABEL.QUANTITY"), styles: {flex: '0 0 7%', cellAlignment: CellAlignmentEnum.CENTER}},
      {key: 'ActivatedDate', display: this.translate.instant("GENERIC_FIELDS.ACTIVATED_DATE"),type: TypeColumn.Date, styles: {flex: '0 0 7%'}},
      {key: 'ActivatedQuantity', display: this.translate.instant("GENERIC_FIELDS.ACTIVATED_QUANTITY"), styles: {flex: '0 0 8%', cellAlignment: CellAlignmentEnum.CENTER}},
    ];

    this.purchasedLicensesColumns = [
      {key: 'action', display: '', type: TypeColumn.SimpleAction, styles: {flex: '0 0 6%'},
        actions: [
          {
            name: '',
            icon: 'visibility',
            fn: (element) => this.showDetails(2, element)
          }
        ]
      },
      {key: 'CompanyDenomination', display: this.translate.instant("GENERIC_FIELDS.DENOMINATION"), styles: {flex: '0 0 20%'}},
      // {key: 'CompanyName', display: this.translate.instant("GENERIC_FIELDS.NAME")},
      // {key: 'CompanySurname', display: this.translate.instant("GENERIC_FIELDS.SURNAME")},
      {key: 'CompanyVatNumber', display: this.translate.instant("GENERIC_FIELDS.VATNUMBER"), styles: {flex: '0 0 10%'}},
      // {key: 'CompanyFiscalCode', display: this.translate.instant("GENERIC_FIELDS.FISCALCODE")},
      {key: 'CommercialProductCode', display: this.translate.instant("GENERIC_FIELDS.CODE"), styles: {flex: '0 0 7%'}},
      {key: 'CommercialProductTitle', display: this.translate.instant("GENERIC_FIELDS.TITLE")},
      // {key: 'CommercialProductCredits', display: this.translate.instant("GENERIC_FIELDS.CREDITS")},
      {key: "CommercialProductCategoryEnum", display: this.translate.instant("GENERIC_FIELDS.CATEGORY"),styles: {flex: '0 0 9%'}, type:TypeColumn.Enum, enumModel:CommercialProductCategoryEnum, multilanguagePrefixKey: "ENUMS.COMMERCIAL_PRODUCT_CATEGORY."},
      {key: 'CommercialProductStartDate', display: this.translate.instant("GENERIC_FIELDS.START_DATE"),type: TypeColumn.Date, styles: {flex: '0 0 7%'}},
      {key: 'CommercialProductEndDate', display: this.translate.instant("GENERIC_FIELDS.END_DATE"),type: TypeColumn.Date, styles: {flex: '0 0 7%'}},
      {key: 'CommercialProductInvoiceQuantity', display: this.translate.instant("GENERIC_LABEL.QUANTITY"), styles: {flex: '0 0 7%', cellAlignment: CellAlignmentEnum.CENTER}},
      {key: 'PurchaseDate', display: this.translate.instant("GENERIC_FIELDS.PURCHASED_DATE"),type: TypeColumn.Date, styles: {flex: '0 0 7%'}},
      {key: 'PurchaseQuantity', display: this.translate.instant("GENERIC_FIELDS.PURCHASED_QUANTITY"), styles: {flex: '0 0 8%', cellAlignment: CellAlignmentEnum.CENTER}},
    ];

    this.receivedLicensesColumns = [
      {key: 'action', display: '', type: TypeColumn.SimpleAction, styles: {flex: '0 0 6%'},
        actions: [
          {
            name: '',
            icon: 'visibility',
            fn: (element) => this.showDetails(3, element)
          }
        ]
      },
      {key: 'CompanyFromDenomination', display: this.translate.instant("GENERIC_FIELDS.DENOMINATION_FROM"), styles: {flex: '0 0 15%'}},
      // {key: 'CompanyFromName', display: this.translate.instant("GENERIC_FIELDS.NAME")},
      // {key: 'CompanyFromSurname', display: this.translate.instant("GENERIC_FIELDS.SURNAME")},
      {key: 'CompanyToDenomination', display: this.translate.instant("GENERIC_FIELDS.DENOMINATION_TO"), styles: {flex: '0 0 15%'}},
      // {key: 'CompanyToName', display: this.translate.instant("GENERIC_FIELDS.NAME")},
      // {key: 'CompanyToSurname', display: this.translate.instant("GENERIC_FIELDS.SURNAME")},
      // {key: 'UserEmail', display: this.translate.instant("GENERIC_FIELDS.EMAIL")},
      {key: 'CommercialProductCode', display: this.translate.instant("GENERIC_FIELDS.CODE"), styles: {flex: '0 0 7%'}},
      {key: 'CommercialProductTitle', display: this.translate.instant("GENERIC_FIELDS.TITLE")},
      // {key: 'Credits', display: this.translate.instant("GENERIC_FIELDS.CREDITS")},
      {key: "CommercialProductCategoryEnum", display: this.translate.instant("GENERIC_FIELDS.CATEGORY"),styles: {flex: '0 0 9%'}, type:TypeColumn.Enum, enumModel:CommercialProductCategoryEnum, multilanguagePrefixKey: "ENUMS.COMMERCIAL_PRODUCT_CATEGORY."},
      {key: 'StartDate', display: this.translate.instant("GENERIC_FIELDS.START_DATE"), type: TypeColumn.Date, styles: {flex: '0 0 7%'}},
      {key: 'EndDate', display: this.translate.instant("GENERIC_FIELDS.END_DATE"),type: TypeColumn.Date, styles: {flex: '0 0 7%'}},
      {key: 'InvoiceQuantity', display: this.translate.instant("GENERIC_LABEL.QUANTITY"), styles: {flex: '0 0 7%', cellAlignment: CellAlignmentEnum.CENTER}},
      {key: 'TransferredDate', display: this.translate.instant("GENERIC_FIELDS.TRANSFERRED_DATE"),type: TypeColumn.Date, styles: {flex: '0 0 8%'}},
      {key: 'TransferredQuantity', display: this.translate.instant("GENERIC_FIELDS.TRANSFERRED_QUANTITY"), styles: {flex: '0 0 9%', cellAlignment: CellAlignmentEnum.CENTER}},
    ]

    this.transferredLicensesColumns = [
      {key: 'action', display: '', type: TypeColumn.SimpleAction, styles: {flex: '0 0 6%'},
        actions: [
          {
            name: '',
            icon: 'visibility',
            fn: (element) => this.showDetails(3, element)
          }
        ]
      },
      {key: 'CompanyFromDenomination', display: this.translate.instant("GENERIC_FIELDS.DENOMINATION_FROM"), styles: {flex: '0 0 15%'}},
      // {key: 'CompanyFromName', display: this.translate.instant("GENERIC_FIELDS.NAME")},
      // {key: 'CompanyFromSurname', display: this.translate.instant("GENERIC_FIELDS.SURNAME")},
      {key: 'CompanyToDenomination', display: this.translate.instant("GENERIC_FIELDS.DENOMINATION_TO"), styles: {flex: '0 0 15%'}},
      // {key: 'CompanyToName', display: this.translate.instant("GENERIC_FIELDS.NAME")},
      // {key: 'CompanyToSurname', display: this.translate.instant("GENERIC_FIELDS.SURNAME")},
      // {key: 'UserEmail', display: this.translate.instant("GENERIC_FIELDS.EMAIL")},
      {key: 'CommercialProductCode', display: this.translate.instant("GENERIC_FIELDS.CODE"), styles: {flex: '0 0 7%'}},
      {key: 'CommercialProductTitle', display: this.translate.instant("GENERIC_FIELDS.TITLE")},
      // {key: 'Credits', display: this.translate.instant("GENERIC_FIELDS.CREDITS")},
      {key: "CommercialProductCategoryEnum", display: this.translate.instant("GENERIC_FIELDS.CATEGORY"),styles: {flex: '0 0 9%'}, type:TypeColumn.Enum, enumModel:CommercialProductCategoryEnum, multilanguagePrefixKey: "ENUMS.COMMERCIAL_PRODUCT_CATEGORY."},
      {key: 'StartDate', display: this.translate.instant("GENERIC_FIELDS.START_DATE"), type: TypeColumn.Date, styles: {flex: '0 0 7%'}},
      {key: 'EndDate', display: this.translate.instant("GENERIC_FIELDS.END_DATE"),type: TypeColumn.Date, styles: {flex: '0 0 7%'}},
      {key: 'InvoiceQuantity', display: this.translate.instant("GENERIC_LABEL.QUANTITY"), styles: {flex: '0 0 7%', cellAlignment: CellAlignmentEnum.CENTER}},
      {key: 'TransferredDate', display: this.translate.instant("GENERIC_FIELDS.TRANSFERRED_DATE"),type: TypeColumn.Date, styles: {flex: '0 0 8%'}},
      {key: 'TransferredQuantity', display: this.translate.instant("GENERIC_FIELDS.TRANSFERRED_QUANTITY"), styles: {flex: '0 0 9%', cellAlignment: CellAlignmentEnum.CENTER}},
    ];

  }

  async loadData(){
    let activated = await this.licenseService.getAllActivatedLicences(GlobalService.getUsedCompany());
    this.activatedLicensesData = activated.map((x: any, i) => { x.ID = i + 1; return x });

    let purchased = await this.licenseService.getAllPurchasedLicences(GlobalService.getUsedCompany());
    this.purchasedLicensesData = purchased.map((x: any, i) => { x.ID = i + 1; return x });

    let received = await this.licenseService.getAllTransferredLicencesToCompany(GlobalService.getUsedCompany());
    this.receivedLicensesData = received.map((x: any, i) => { x.ID = i + 1; return x });

    let transferred = await this.licenseService.getAllTransferredLicencesFromCompany(GlobalService.getUsedCompany());
    this.transferredLicensesData = transferred.map((x: any, i) => { x.ID = i + 1; return x });
  }

  /**
   * Mostra i dettagli di una licenza (non è possibile mostrare tutti i dettagli all'interno della tabella)
   * @param type 1 = activated, 2 = purchased, 3 = received/transferred
   * @param element elemento di cui mostrare il dettaglio
   */
  showDetails(type:number, element){
    this.typeToShow = type;
    this.elementToShow = element;
    if(this.elementToShow.CommercialProductCategoryEnum == 1){
      this.category = this.translate.instant("ENUMS.COMMERCIAL_PRODUCT_CATEGORY.EFT");
    }else{
      this.category = this.translate.instant("ENUMS.COMMERCIAL_PRODUCT_CATEGORY.PLUS");
    }

    this.detailsModalRef = this.dialog.open(this.detailsModal,
      {
        disableClose: false,
        hasBackdrop: true,
        width: '70%',
        minHeight: '400px',
      });
  }

  closeDetailsModal(){
    this.detailsModalRef.close();
  }


}
